import { Modal } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AddTagReviewAndSubmit, AddTagTable } from '@hero/organisms';

import { ADD_TAG_STEPS } from './constant';

function AddTagModal({ ids, openModal, onRequestClose, onUpdate }) {
  const { t } = useTranslation();
  const defaultTags = ids.reduce((acc, cur) => ({ ...acc, [cur]: true }), {});
  const [selectedRows, onChangeSelectedRows] = useState(defaultTags);

  const [step, setStep] = useState(ADD_TAG_STEPS.ADD_TAG_TABLE);
  const [footerProps, setFooterProps] = useState({});
  const [modalHeader, setModalHeader] = useState({
    title: t('addTags'),
    onBack: ''
  });

  const addTagSteps = {
    [ADD_TAG_STEPS.ADD_TAG_TABLE]: AddTagTable,
    [ADD_TAG_STEPS.REVIEW_TAGS]: AddTagReviewAndSubmit
  };

  const Component = addTagSteps[step];

  return (
    <Modal
      isOpen={openModal}
      onRequestClose={onRequestClose}
      {...modalHeader}
      primaryButtonProps={{
        onClick: footerProps?.rightButtonOnClick,
        children: footerProps?.rightButtonText,
        disabled: !footerProps?.isRightButtonActive,
        loading: footerProps?.isRightButtonLoading,
        endIcon: footerProps?.rightButtonEndIcon
      }}
      secondaryButtonProps={{
        onClick: footerProps?.leftButtonOnClick,
        children: footerProps?.leftButtonText,
        disabled: !footerProps?.isLeftButtonActive
      }}
      size="xl"
    >
      <Component
        setStep={setStep}
        setModalHeader={setModalHeader}
        setFooterProps={setFooterProps}
        onRequestClose={onRequestClose}
        selectedRows={selectedRows}
        tagRows={defaultTags}
        onChangeSelectedRows={onChangeSelectedRows}
        onUpdate={onUpdate}
        isModal
      />
    </Modal>
  );
}

export { AddTagModal };
